// Shared DataGrid theme so every table on the site (Admin, Realtor Tools,
// Dashboard, etc.) uses the same white-on-amber header instead of MUI's
// default light theme, which clashes with the site's dark background.
export const dataGridSx = {
    color: '#ffffff',
    fontFamily: 'serif',
    border: 'none',
    // MUI X DataGrid v8 paints the header row background from this CSS
    // variable (defaults to theme.palette.background.default, i.e. white,
    // since this app has no dark ThemeProvider) rather than from a plain
    // ".MuiDataGrid-columnHeaders { backgroundColor }" rule.
    '--DataGrid-containerBackground': 'rgba(120, 53, 15, 0.4)',
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: 'rgba(120, 53, 15, 0.4)',
        color: '#ffffff',
        borderBottom: '2px solid rgba(120, 53, 15, 0.6)',
    },
    '& .MuiDataGrid-cell': {
        borderBottom: '1px solid rgba(120, 53, 15, 0.3)',
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
        outline: 'none',
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
    '& .MuiDataGrid-footerContainer': {
        borderTop: '2px solid rgba(120, 53, 15, 0.6)',
        color: '#ffffff',
    },
    '& .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        color: '#ffffff',
    },
    '& .MuiSvgIcon-root': {
        color: '#ffffff',
    },
    '& .MuiDataGrid-columnSeparator': {
        display: 'none',
    },
};
